import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { SkyDialog, SkyText } from "@skypointcloud/skypoint-ui";
import { clearTokens } from "../../store/slices/authSlice";
import { refusalFor } from "./accessRefusal";
import { logger } from "../../services/logger.service";

interface AccessRefusalDialogProps {
  /** The server's code from the 403 body. Without one there is nothing to say. */
  code: string | undefined;
  onClose: () => void;
}

/**
 * A refused action, said in place (H6). The app stays behind it, the dialog
 * closes on the person's word, and nothing signs them out unless another
 * account is what they actually need.
 */
export const AccessRefusalDialog = ({ code, onClose }: AccessRefusalDialogProps) => {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const refusal = refusalFor(code);
  if (!refusal) return null;

  const signInAsSomeoneElse = () => {
    dispatch(clearTokens());
    instance.logoutRedirect().catch((error) => {
      logger.error("Logout failed", error);
    });
  };

  return (
    <SkyDialog
      open
      onOpenChange={(open) => !open && onClose()}
      title={refusal.title}
      variant="modal"
      primaryAction={{ label: "Close", onClick: onClose }}
      secondaryAction={
        refusal.offerSignOut
          ? { label: "Sign in as someone else", onClick: signInAsSomeoneElse }
          : undefined
      }
    >
      <SkyText size={300}>{refusal.message}</SkyText>
    </SkyDialog>
  );
};

export default AccessRefusalDialog;
